export const TIER = Object.freeze({
  domainGroups: "domain-groups",
  domains: "domains",
  msps: "msps",
  users: "users",
});

export default {};
